import { Card as MuiCard, CardProps } from '@mui/material';

const Card = ({ ...rest }: CardProps) => <MuiCard {...rest} />;

export default Card;
